import Vue from 'vue';
import { gsap, Draggable, Linear } from 'gsap/all';
import { InertiaPlugin } from '../gsap-bonus/InertiaPlugin';
import { CustomEase } from '../gsap-bonus/CustomEase';

gsap.registerPlugin(Draggable);
gsap.registerPlugin(InertiaPlugin);
gsap.registerPlugin(CustomEase);

Vue.component('scroll-navigation-component', {
    props: {
        projects: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            activeItem: null,
            scrolling: false,
            draggableIndex: 0,
            activeIndex: 0,
            ready: false
        };
    },

    mounted() {
        Vue.nextTick(() => {
            this.initDraggable();
        });

        EventBus.$on('window-resize', this.initDraggable);
    },

    methods: {
        initDraggable() {
            var wrapper = document.querySelector('.scroll-navigation');
            var boxes = [...document.querySelectorAll('.scroll-navigation__list-item')];
            this.images = [...document.querySelectorAll('.scroll-navigation__visuals-visual')];
            var boxHeightValue = document.querySelector('.scroll-navigation__list-item');
            var boxHeight = boxHeightValue.clientHeight;
            var wrapHeight = boxes.length * boxHeight;

            CustomEase.create("generalEase", "0.45, 0, 0.33, 1");

            this.initialProjectIndex = 0;
            this.items = boxes.map((item, index) => {
                const box = item.getBoundingClientRect();

                return {
                    el: item,
                    width: box.width,
                    height: box.height,
                };
            });

            this.sizes = this.items.reduce(
                (t, e) => ({
                    totalHeight: t.totalHeight + e.height,
                    maxItemWidth: Math.max(t.maxItemWidth, e.width),
                    maxItemHeight: Math.max(t.maxItemHeight, e.height),
                }),
                {
                    totalHeight: 0,
                    maxItemWidth: 0,
                    maxItemHeight: 0,
                }
            );

            const { totalWidth, maxItemWidth, maxItemHeight } = this.sizes;

            let i = 0;
            this.items.forEach((item) => {
                item.xCenter =
                    maxItemWidth + (window.innerWidth - item.width) / 2 - i;
                item.yCenter =
                    maxItemHeight +
                    (wrapper.getBoundingClientRect().height - item.height) / 2 -
                    i;
                i += item.height;
            });

            for (var j = 0; j < boxes.length; j++) {
                let box = boxes[j];
                gsap.set(box, { y: j * boxHeight, top: -boxHeight });
            }

            var wrapProgress = gsap.utils.wrap(0, 1);
            var snapBox = gsap.utils.snap(boxHeight);
            var clickAnimation = gsap.set({}, {});
            var proxy = document.createElement('div');
            var props = gsap.getProperty(proxy);

            var animation = gsap
                .to('.scroll-navigation__list-item', {
                    duration: 5,
                    y: '+=' + wrapHeight,
                    ease: Linear.easeNone,
                    paused: true,
                    repeat: -1,
                    modifiers: {
                        y: function (y, target) {
                            y = parseFloat(y) % wrapHeight;
                            return y + 'px';
                        },
                    },
                })
                .progress(1 / boxes.length);

            const snapFunc = (t) => {
                const initialCenter =
                    this.items[this.initialProjectIndex].yCenter;
                const r = t + initialCenter;
                const n = this.items[0];
                const i = this.items[this.items.length - 1];
                const a = n.yCenter + n.height / 2;
                const o = i.yCenter - i.height / 2;

                let s = 0;
                if (r > a) {
                    for (; r + s > a;) s -= this.sizes.totalHeight;
                } else if (r < o) {
                    for (; r + s < o;) s += this.sizes.totalHeight;
                }

                const c = r + s;
                const h = this.items.findIndex(
                    (t) =>
                        t.yCenter - t.height / 2 < c &&
                        t.yCenter + t.height / 2 > c
                );

                let newIndex = h + 3;
                if (newIndex > this.items.length - 1) {
                    newIndex = newIndex - this.items.length;
                }

                this.activeIndex = newIndex;

                return snapBox(t);
            };

            var that = this;
            const draggable = Draggable.create(proxy, {
                type: 'y',
                trigger: '.scroll-navigation',
                onDrag: updateProgress,
                onDragEnd: function () {
                    gsap.delayedCall(this.tween.duration() - 1, () => {
                        if (that.images[that.activeIndex] != that.images[that.draggableIndex]) {
                            const nextImage = that.images[that.activeIndex];
                            const previousImage = that.images[that.draggableIndex];

                            previousImage.style.zIndex = '1';
                            nextImage.style.zIndex = '2';

                            gsap.to(nextImage, {
                                duration: 1, scale: 1, autoAlpha: 1, ease: 'generalEase', onComplete: () => {
                                    gsap.set(previousImage, { autoAlpha: 0, scale: 1.15 });
                                }
                            });
                        }

                        that.draggableIndex = that.activeIndex;
                    });
                },
                inertia: true,
                onThrowUpdate: updateProgress,
                snap: {
                    y: snapFunc,
                },
            });

            function updateProgress(tween) {
                // console.log(InertiaPlugin.getVelocity(tween.target));
                animation.progress(wrapProgress(props('y') / wrapHeight));
            }

            updateProgress();
            this.activeIndex = this.initialProjectIndex + 3;
            this.draggableIndex = this.initialProjectIndex + 3;

            gsap.set(this.images[this.draggableIndex], { autoAlpha: 1 });

            this.ready = true;

            this.goUp = () => {
                if (clickAnimation.isActive()) return;
                this.activeIndex = this.activeIndex - 1;
                if (this.activeIndex < 0) {
                    this.activeIndex = this.items.length - 1;
                }

                animateCarousel(1, this.activeIndex, this.draggableIndex);
                this.draggableIndex = this.activeIndex;
            };

            this.goDown = () => {
                if (clickAnimation.isActive()) return;
                this.activeIndex = this.activeIndex + 1;
                if (this.activeIndex > this.items.length - 1) {
                    this.activeIndex = 0;
                }

                animateCarousel(-1, this.activeIndex, this.draggableIndex);
                this.draggableIndex = this.activeIndex;
            };

            function animateCarousel(direction, activeIndex, draggableIndex) {
                clickAnimation.kill();

                clickAnimation = gsap.to(proxy, {
                    duration: 0.8,
                    y: snapBox(props('y') + direction * boxHeight),
                    onUpdate: updateProgress,
                });

                const nextImage = that.images[activeIndex];
                const previousImage = that.images[draggableIndex];

                previousImage.style.zIndex = '1';
                nextImage.style.zIndex = '2';

                gsap.to(nextImage, {
                    duration: 1, scale: 1, autoAlpha: 1, ease: 'generalEase', onComplete: () => {
                        gsap.set(previousImage, { autoAlpha: 0, scale: 1.15 });
                    }
                });
            }

            // this.onKeyDownDebounced = this.handleKeyDown.bind(this);
            document.addEventListener('keydown', this.handleKeyDown);
            this.listenForScroll();
        },

        listenForScroll() {
            this.lethargy = new Lethargy(20, 120, 0.05);

            // Cross-browser way to bind to mouse events
            window.addEventListener('mousewheel', this.onUserScroll);
            window.addEventListener('DOMMouseScroll', this.onUserScroll);
            window.addEventListener('wheel', this.onUserScroll);
            window.addEventListener('MozMousePixelScroll', this.onUserScroll);
        },

        removeScrollListener() {
            this.lethargy = null;

            // Cross-browser way to bind to mouse events
            window.removeEventListener('mousewheel', this.onUserScroll);
            window.removeEventListener('DOMMouseScroll', this.onUserScroll);
            window.removeEventListener('wheel', this.onUserScroll);
            window.removeEventListener(
                'MozMousePixelScroll',
                this.onUserScroll
            );
        },

        onUserScroll: _.throttle(function (e) {
            // e.preventDefault();
            // e.stopPropagation();

            if (!this.lethargy) {
                return;
            }

            if (this.scrolling) {
                return;
            }

            this.scrolling = true;

            console.log(this.scrolling);

            gsap.delayedCall(0.6, () => {
                this.scrolling = false;
            });

            const result = this.lethargy.check(e);

            // false means it's not a scroll intent, 1 or -1 means it is
            if (result === -1) {
                this.goDown();
            } else if (result === 1) {
                this.goUp();
            }
        }),

        handleKeyDown: _.throttle(function (event) {
            if (event.key === 'ArrowUp' || event.key === 'Up') {
                this.goUp();
                return;
            }

            if (event.key === 'ArrowDown' || event.key === 'Down') {
                this.goDown();
                return;
            }

            if (event.key === 'Enter') {
                this.goToProject(this.draggableIndex);
                return;
            }
        }, 500),
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
        this.removeScrollListener();
    },
});